import React from 'react';
import PropTypes from 'prop-types';

/**
 * Shows up when there are no lessons in courses, i.e a lesson is empty.
 * Also used for the quiz builder
 *
 * @param {Object} props
 * @param {string} props.type
 * @param {string} props.content
 */
const EmptyEntity = ( { type, content } ) => (
	<div className="ld__builder--empty-entity">
		<p>
			{ `${ LearnDashData.labels[ type ] } ${ LearnDashData.i18n.no_content }` }
		</p>
		<p>
			{ `${ LearnDashData.i18n.add_content } ${ LearnDashData.labels[ content ] } ${ LearnDashData.i18n.add_from_sidebar }` }
		</p>
	</div>
);

/**
 * Valid props
 */
EmptyEntity.propTypes = {
	type: PropTypes.string,
	content: PropTypes.string,
};

export default EmptyEntity;
